import { useReduxState } from 'hooks';
import api from 'api';
import { ConfirmButton, ConfirmDeleteButton } from 'components/common';

interface Props {
  itemId?: number;
  pathId: number;
  updateUsers: () => Promise<void>;
  userId: number;
}

const PathParticipantDeleteCompletion = ({
  pathId,
  updateUsers,
  userId
}: Props) => {
  const {
    messages,
    serverConfig: { requireReasonWhenDeletingData }
  } = useReduxState();

  const handleDelete = async (values?: { deletionReason?: string }) => {
    try {
      let url = `/admin/paths/${pathId}/completions/${userId}`;

      if (values?.deletionReason) {
        url += `?deletionReason=${encodeURIComponent(values.deletionReason)}`;
      }

      await api.delete(url);
      await updateUsers();
      return true;
    } catch (err) {
      return false;
    }
  };

  return requireReasonWhenDeletingData ? (
    <ConfirmDeleteButton
      buttonIsDropdown={true}
      buttonText={messages.completionManuallyMarkIncomplete}
      confirmText={messages.pathRemoveCompletionConfirm}
      confirmTitle={messages.completionManuallyMarkIncomplete}
      id="deletionReasonPathCompletion"
      onConfirm={handleDelete}
      successMessage={messages.pathRemoveCompletionSuccess}
    />
  ) : (
    <ConfirmButton
      actionText={messages.commonDelete}
      buttonIcon="trash-alt"
      buttonIsDropdown={true}
      buttonText={messages.completionManuallyMarkIncomplete}
      category="danger"
      confirmText={messages.pathRemoveCompletionConfirm}
      confirmTitle={messages.completionManuallyMarkIncomplete}
      onConfirm={handleDelete}
      successMessage={messages.pathRemoveCompletionSuccess}
    />
  );
};

export default PathParticipantDeleteCompletion;
